/**
 * Verifica si el valor proporcionado es un array válido.
 * Si no lo es, devuelve un array vacío.
 *
 * @param {any} value - El valor a verificar
 * @returns {Array} - Un array válido o un array vacío
 */
export function getValidArray(value) {
  if (Array.isArray(value)) {
    return value
  }

  return []
}
